module.exports = __webpack_public_path__ + "img/workflow-2.7604b62a.png";